angular.module('common.directives').directive('mapMediaPlayers', function () {
  return {
    scope: {
      organizationId: '='
    },
    templateUrl: './templates/map-media-players.views.html?t=' + webpackHash,
    controller: 'mapMediaPlayersCtrl',
    link: function ($scope, $element) {}
  }
})
